import React from 'react'
import { useTranslation } from 'react-i18next'
import { Control, FieldErrors } from 'react-hook-form'
import { ControlledTextField } from '../../../form/ControlledTextField'
import { FormGroup } from '../../../form/FormGroup'
import { validators } from '../../../../validation/validators'
import { InternalFormValues } from '../form-values'
import { ControlledHourSeriesSelect } from '../../../form/ControlledHourSeriesSelect'
import {
  HourSeriesCollectionFragment,
  HourSeriesType,
} from '../../../../generated/graphql'
import { ControlledSwitch } from '../../../form/ControlledSwitch'

type Props = {
  control: Control<InternalFormValues>
  errors: FieldErrors<InternalFormValues>
  hourSeriesCollections: HourSeriesCollectionFragment[]
}

export function SolarPanelForm({
  control,
  errors,
  hourSeriesCollections,
}: Props): React.ReactElement {
  const { t } = useTranslation()

  return (
    <>
      <FormGroup>
        <ControlledHourSeriesSelect
          id="hour-series-picker-hourSeriesIds"
          control={control}
          name="hourSeriesIds"
          rules={{ ...validators.notEmpty }}
          error={errors.hourSeriesIds}
          label={t('createProvider.forms.solarPanel.hourSeries')}
          collections={hourSeriesCollections}
          filter={(hourSeries) =>
            hourSeries.type === HourSeriesType.SolarPanelRatedPowerDensity
          }
        />
      </FormGroup>

      <FormGroup>
        <ControlledTextField
          control={control}
          name="parameters.solarPanel.area"
          rules={{
            ...validators.required,
            ...validators.area,
          }}
          error={errors.parameters?.solarPanel?.area}
          label={t('createProvider.forms.solarPanel.area')}
        />
      </FormGroup>

      <FormGroup>
        <ControlledTextField
          control={control}
          name="parameters.solarPanel.solarEfficiency"
          rules={{
            ...validators.required,
            ...validators.efficiency,
          }}
          error={errors.parameters?.solarPanel?.solarEfficiency}
          label={t('createProvider.forms.solarPanel.solarEfficiency')}
          defaultValue="0.16"
        />
      </FormGroup>

      <FormGroup>
        <ControlledTextField
          control={control}
          name="parameters.solarPanel.ratingEfficiency"
          rules={{
            ...validators.required,
            ...validators.efficiency,
          }}
          error={errors.parameters?.solarPanel?.ratingEfficiency}
          label={t('createProvider.forms.solarPanel.ratingEfficiency')}
          defaultValue="0.16"
        />
      </FormGroup>

      <FormGroup>
        <ControlledSwitch
          control={control}
          name="parameters.solarPanel.isWasteSold"
          label={t('createProvider.forms.solarPanel.isWasteSold')}
        />
      </FormGroup>
    </>
  )
}
